module.exports = __webpack_public_path__ + "img/26_154.0d86d3a9.png";